// src/components/data-display/DataTileRealBlockTime.jsx
import { SingleDataValue } from '../data-display';
import { ThemedFlex } from '../../theme/ThemedFlex';
import { getFallbackValue } from '../../utils/fallbackCalculations';
import { useRecoilValue } from 'recoil';
import { recentBlocksState } from '../../recoilState';

export const DataTileRealBlockTime = ({ data, blockMetrics, formatNumber, animate }) => {
  const recentBlocks = useRecoilValue(recentBlocksState);

  // Priority: blockMetrics from event-driven system, then fallback calculation
  const blockTime = blockMetrics?.avgBlockTime || getFallbackValue('avgBlockTime', {
    recentBlocks,
    s091: data?.s091
  });

  const avgBlockTime = blockTime != null
    ? `${formatNumber(blockTime / 60, 1)} Mins`
    : '';

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <SingleDataValue label="Avg Blk Time 24h" value={avgBlockTime} />
    </ThemedFlex>
  );
};